import { Chip, Tooltip } from '@mui/material';
import React from 'react';
import { CHIP_VARIANTS } from '../../constants/constants';
import I18n from '../../i18n/I18n';

export interface ExportChipProps {
    titleToken: string;
    labelToken: string;
}

export const ExportChip = ({ titleToken, labelToken }: ExportChipProps) => {
    return (
        <Tooltip title={<I18n token={titleToken} />}>
            <Chip label={<I18n token={labelToken} />} variant={CHIP_VARIANTS.outlined} sx={{ mx: 1 }} />
        </Tooltip>
    );
};
